<mat-card class="preview-card">
  <mat-card-header>
    <mat-icon mat-card-avatar class="preview-icon">{{ getFileIcon(file.type) }}</mat-icon>
    <mat-card-title>{{ file.name }}</mat-card-title>
    <mat-card-subtitle>{{ file.type }}</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <div class="file-info">
      <div class="info-row">
        <span class="info-label">Date :</span>
        @if(file.dateModification !== "0000-00-00T00:00:00.000"){
        <span>{{ file.dateModification | date:'dd/MM/yyyy HH:mm' }}</span>
        }@else {
        <span>{{ file.creationDate | date:'dd/MM/yyyy' }}</span>
        }
      </div>
      <div class="info-row">
        <span class="info-label">Taille :</span>
        <span>{{ file.taille || 'N/A' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Type :</span>
        <span>{{ file.type }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Dossier :</span>
        <span>{{ folderName }}</span>
      </div>
    </div>

    @if(isImage(file.type)){
    <div class="preview-content">
      @if(!fileLoaded){
      <app-loader size="2" style="margin-block: 5px;"></app-loader>
      }
      @if(file.id){
      <img [src]="('files/' + file.id)|apiUrl:file.dateModification"
        (load)="fileLoadedChange.emit(true)" [alt]="file.name" class="preview-image"
        [class.hidden]="!fileLoaded">
      <button mat-raised-button color="primary" (click)="openFile()">
        <mat-icon>open_in_new</mat-icon>
        Ouvrir
      </button>
      }
    </div>
    }

    @if(isPDF(file.type)){
    <div class="preview-content">
      <mat-icon class="large-icon">picture_as_pdf</mat-icon>
      <p>Document PDF</p>
      <button mat-raised-button color="primary" (click)="openFile()">
        <mat-icon>open_in_new</mat-icon>
        Ouvrir
      </button>
    </div>
    }

  </mat-card-content>
</mat-card>
